import { createFileRoute } from "@tanstack/react-router";

import { PasswordResetPage } from "pages/password-reset";

export const Route = createFileRoute("/password-reset/$token")({
  component: PasswordResetPage,
  onError: console.error,
});
